import { AccessDenied } from "@/components/shared/AccessDenied";
import { NotFound } from "@/components/shared/NotFound";
import { SCHOOL_STAFF_ROLES } from "@/lib/constants/roles";
import { Navigate, Outlet, createFileRoute } from "@tanstack/react-router";
import { useAuth } from "../contexts/AuthContext";

function TeacherLayout() {
  const { user, isAuthenticated, isPending } = useAuth();

  if (isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" search={{ redirect: "/teacher" }} />;
  }

  if (!user?.role || !SCHOOL_STAFF_ROLES.includes(user.role)) {
    return <AccessDenied description="This area is for school staff accounts." />;
  }

  return <Outlet />;
}

function TeacherErrorComponent() {
  return (
    <NotFound
      title="Something went wrong"
      description="The resource you're looking for could not be found or is invalid."
    />
  );
}

export const Route = createFileRoute("/teacher")({
  component: TeacherLayout,
  notFoundComponent: NotFound,
  errorComponent: TeacherErrorComponent,
});
